import script from "./CrudMoldes.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudMoldes.vue?vue&type=script&setup=true&lang=js"

import "./CrudMoldes.vue?vue&type=style&index=0&id=3fa4b220&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fa4b220"]])

export default __exports__